module.exports = __webpack_public_path__ + "media/images/money_box-b1c94b77c8a949bea4c7cc97804dbf9f.svg";